export default __webpack_public_path__ + "static/media/rory-houlding-cv.d80966fd.pdf";